import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import all language files
import tr from './locales/tr.js';
import en from './locales/en.js';
import de from './locales/de.js';
import es from './locales/es.js';
import fr from './locales/fr.js';
import it from './locales/it.js';
import pt from './locales/pt.js';
import ru from './locales/ru.js';
import zh from './locales/zh.js';
import ja from './locales/ja.js';
import ar from './locales/ar.js';
import hi from './locales/hi.js';
import ko from './locales/ko.js';
import nl from './locales/nl.js';
import sv from './locales/sv.js';
import pl from './locales/pl.js';
import uk from './locales/uk.js';
import fa from './locales/fa.js';
import el from './locales/el.js';
import he from './locales/he.js';
import id from './locales/id.js';

const resources = {
  tr: { translation: tr },
  en: { translation: en },
  de: { translation: de },
  es: { translation: es },
  fr: { translation: fr },
  it: { translation: it },
  pt: { translation: pt },
  ru: { translation: ru },
  zh: { translation: zh },
  ja: { translation: ja },
  ar: { translation: ar },
  hi: { translation: hi },
  ko: { translation: ko },
  nl: { translation: nl },
  sv: { translation: sv },
  pl: { translation: pl },
  uk: { translation: uk },
  fa: { translation: fa },
  el: { translation: el },
  he: { translation: he },
  id: { translation: id }
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem('lang') || 'tr',
  fallbackLng: 'tr',
  interpolation: { escapeValue: false }
});

export const changeLanguage = (language) => {
  i18n.changeLanguage(language);
  localStorage.setItem('lang', language);
};

export default i18n; 